import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (Control + API) eager zu ziehen.
 *
 * Die Bedienelemente werden inline in <Input> / <Textarea> gerendert (kein
 * Slot) — das Skill existiert hier nur, damit es im Frontend-Registry sichtbar
 * ist und im Skill-Inventar mit klarem Namen und Beschreibung auftaucht.
 */
const manifest: SkillManifest = {
  key: 'ai-text-rewrite',
  name: 'KI je Feld',
  description:
    'KI-Aktionen an Freitextfeldern: Aus Stichworten erzeugen, Umformulieren, Kürzen, Erweitern, Fachsprache, Feld leeren — mit Rückgängig und farblicher Kennzeichnung ungeprüfter KI-Texte.',
  category: 'ai',
  version: '0.2.0',
  requiredPermissions: [Permission.AI_USE],
  enabledByDefault: true,
};

export const aiTextRewriteSkill: FrontendSkill = {
  manifest,
};
